export const REGULAR_EXPRESSION = {
  CHECK_WORK_SPACING: '^ *(?:(?:\\S| ){1,22}\\S)(?: +(?:\\S| ){1,22}\\S)* *$' // /^ *(?:(?:\S| ){1,22}\S)(?: +(?:\S| ){1,22}\S)* *$/)
};
